import React from "react";
import { FaReact, FaCoffee, FaHeart } from "react-icons/fa";
import {
  Box,
  Text,
  Link,
  VStack,
  HStack,
  Button,
  Divider,
  Icon,
  Container,
} from "@chakra-ui/react";

const Footer = () => {
  return (
    <Box
      bg="linear-gradient(180deg, rgba(26,32,44,0.95), rgba(17,21,28,1))"
      position="relative"
      overflow="hidden"
    >
      {/* Gradient top border — matches the animated borders from other components */}
      <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        height="2px"
        bgGradient="linear(to-r, teal.300, cyan.400, teal.300)"
        opacity={0.5}
      />

      <Container maxW="1200px" py={{ base: 6, md: 8 }} px={{ base: 3, md: 4 }}>
        <VStack spacing={{ base: 4, md: 6 }}>
          {/* Main Message */}
          <VStack spacing={2} textAlign="center" maxW="700px">
            <Text
              fontSize={{ base: "md", md: "lg" }}
              fontWeight="semibold"
              bgGradient="linear(to-r, teal.300, blue.400)"
              bgClip="text"
            >
              Built with love for Mattias 💙
            </Text>
            <Text
              fontSize={{ base: "xs", md: "sm" }}
              color="gray.400"
              lineHeight="tall"
              px={{ base: 2, md: 0 }}
            >
              This project helps track what matters most for Mattias' future.
              Your support goes directly into his long-term investment fund 📈👶
            </Text>
          </VStack>

          {/* Support Buttons — stack vertically on very small screens */}
          <HStack
            spacing={{ base: 2, sm: 4 }}
            flexDirection={{ base: "column", sm: "row" }}
            w={{ base: "full", sm: "auto" }}
            justify="center"
          >
            <Button
              as={Link}
              href="https://paypal.me/angelindga"
              isExternal
              leftIcon={<FaCoffee />}
              colorScheme="teal"
              variant="solid"
              size={{ base: "sm", md: "md" }}
              w={{ base: "full", sm: "auto" }}
              _hover={{
                transform: "translateY(-2px)",
                boxShadow: "lg",
                textDecoration: "none",
              }}
              transition="all 0.2s"
            >
              Buy a Coffee ☕
            </Button>

            <Button
              as={Link}
              href="https://revolut.me/angelin_dan"
              isExternal
              leftIcon={<FaHeart />}
              colorScheme="pink"
              variant="solid"
              size={{ base: "sm", md: "md" }}
              w={{ base: "full", sm: "auto" }}
              _hover={{
                transform: "translateY(-2px)",
                boxShadow: "lg",
                textDecoration: "none",
              }}
              transition="all 0.2s"
            >
              Support on Revolut
            </Button>
          </HStack>

          <Divider borderColor="whiteAlpha.100" />

          {/* Creator & Tech Stack */}
          <VStack spacing={1}>
            <HStack
              spacing={2}
              fontSize={{ base: "xs", md: "sm" }}
              color="gray.400"
              flexWrap="wrap"
              justify="center"
            >
              <Text>Crafted with</Text>
              <Icon as={FaHeart} color="red.400" boxSize={3} />
              <Text>by</Text>
              <Link
                href="https://dan-angelin.com/"
                isExternal
                fontWeight="bold"
                color="teal.300"
                _hover={{ color: "teal.200" }}
              >
                Dan Angelin
              </Link>
            </HStack>

            <HStack
              spacing={2}
              fontSize={{ base: "2xs", md: "xs" }}
              color="gray.500"
              flexWrap="wrap"
              justify="center"
            >
              <Text>&copy; {new Date().getFullYear()} Mattias Assets</Text>
              <Text display={{ base: "none", sm: "block" }}>•</Text>
              <HStack spacing={1}>
                <Text>Built with</Text>
                <Icon as={FaReact} color="cyan.400" />
                <Text>React</Text>
              </HStack>
            </HStack>
          </VStack>
        </VStack>
      </Container>
    </Box>
  );
};

export default Footer;